import { lazy } from "react";

const CommonLayout = lazy(() => import("../layouts/CommonLayout.jsx"));
const ErrorLayout = lazy(() => import("../layouts/ErrorLayout.jsx"));

const AddSongHomeView = lazy(() => import("../views/addSong/AddSongHomeView.jsx"));
const IndexesView = lazy(() => import("../views/indexes/IndexesView.jsx"));
const SongsView = lazy(() => import("../views/songs/SongsView.jsx"));
const SettingsView = lazy(() => import("../views/settings/SettingsView.jsx"));

const InActiveErrorView = lazy(() => import("../views/error/InActiveErrorView.jsx"));

const ThemeRoutes = [
    {
        path: "/",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <AddSongHomeView /> },
            { path: "/idxs", exact: true, element: <IndexesView /> },
            { path: "/songs", exact: true, element: <SongsView /> },
            { path: "/settings", exact: true, element: <SettingsView /> },
        ],
    },
    {
        path: "/error",
        element: <ErrorLayout />,
        children: [
            { path: "/error/inactive", exact: true, element: <InActiveErrorView /> }
        ],
    },

]
export default ThemeRoutes;